import { FC } from 'react';
import type { AddressType } from './types';
import { ArabicFormatAddress } from './formats/ArabicFormatAddress';
import { DefaultFormatAddress } from './formats/DefaultFormatAddress';
import { EastAsiaFormatAddress } from './formats/EastAsiaFormatAddress';
import { EuropeanFormatAddress } from './formats/EuropeanFormatAddress';

interface AddressProps {
  isFullAddress?: boolean;
  locale: string;
  address: AddressType;
  isAddressTypeDisplay?: boolean;
  translatedAddressType?: string;
  isAsianOrder?: boolean;
  translatedPostalSymbol?: string;
  isCompanyNameAddressFlag?: boolean;
  isDropboxAddress?: boolean;
}

export const Address: FC<AddressProps> = ({
  isFullAddress = true,
  locale,
  address,
  isAddressTypeDisplay = false,
  translatedAddressType,
  isAsianOrder,
  translatedPostalSymbol,
  isCompanyNameAddressFlag,
  isDropboxAddress = false
}) => {
  switch (locale) {
    case 'ar_EG':
      return (
        <ArabicFormatAddress
          address={address}
          isFullAddress={isFullAddress}
          isAddressTypeDisplay={isAddressTypeDisplay}
          translatedAddressType={translatedAddressType}
        />
      );
    case 'ja_JP':
    case 'ko_KR':
    case 'zh_CN':
    case 'zh_TW':
      return (
        <EastAsiaFormatAddress
          address={address}
          isFullAddress={isFullAddress}
          isAddressTypeDisplay={isAddressTypeDisplay}
          translatedAddressType={translatedAddressType}
          isAsianOrder={isAsianOrder}
          translatedPostalSymbol={translatedPostalSymbol}
        />
      );
    case 'de_DE':
    case 'es_ES':
    case 'fr_FR':
    case 'it_IT':
    case 'pl_PL':
    case 'ro_RO':
    case 'ru_RU':
      return (
        <EuropeanFormatAddress
          address={address}
          isFullAddress={isFullAddress}
          isAddressTypeDisplay={isAddressTypeDisplay}
          translatedAddressType={translatedAddressType}
        />
      );
    default:
      return (
        <DefaultFormatAddress
          address={address}
          isFullAddress={isFullAddress}
          isAddressTypeDisplay={isAddressTypeDisplay}
          translatedAddressType={translatedAddressType}
          isAsianOrder={isAsianOrder}
          isCompanyNameAddressFlag={isCompanyNameAddressFlag}
          isDropboxAddress={isDropboxAddress}
        />
      );
  }
};
